// extracted by mini-css-extract-plugin
module.exports = {"list":"Navigation_list__2nvLE","item":"Navigation_item__19Ztg","link":"Navigation_link__3Tddu","active":"Navigation_active__m0T1y"};